import { connect } from 'react-redux';

import { loadUserSubscription } from '../actions/accountSettingsAction';
import { resetPracticeExamHistory } from '../actions/dashboardActions.js';
import {
  getPracticeExamQuestions,
  getWeeklyPracticeExams,
  setCheckPracticeExamStatusFlag,
  setExamQuestions,
  setInitialTimePracticeExam,
  setNewDetail,
  setPracticeExam,
  setResultsSummarized,
  setRetakeMode,
  setReviewMode,
  setSubmitPracticeExamSuccess,
  startPracticeExam,
  submitPracticeExam,
  updatePracticeExamResults,
  updateTimerPracticeExam,
} from '../actions/practiceExamActions';
import { getUserSubscription } from '../components/AccountSettings/AccountSettingsSelectors';
import {
  getcheckPracticeExamFlag,
  getcheckPracticeExamLoading,
  getCustomPracticeExam,
  getCustomPracticeExamLoading,
  getCustomPracticeExamRef,
  getCustomPracticeExamReferencesLoading,
  getCustomPracticeExamStatus,
  getExamQuestions,
  getIsLoading,
  getPracticeExam,
  getPracticeExamAvailable,
  getResultsSummarized,
  getRetakeMode,
  getReviewMode,
  getSubmitPracticeExamLoading,
  getSubmitPracticeExamSuccess,
  getTimer,
  getTimerDisplay,
  getTimerStarted,
} from '../components/PracticeExam/PracticeExamSelectors';
import PracticeExamView from '../components/PracticeExam/PracticeExamView.jsx';
import exam from '../components/PracticeExam/questions.json';
import { getUser } from '../components/User/userSelectors';
import { verifyLoggedUser } from '../utils/verifyUserLogged';

const mapStateToProps = (state) => ({
  exam,
  user: getUser(state),
  timerDisplay: getTimerDisplay(state),
  isLoading: getIsLoading(state),
  practiceExamAvailable: getPracticeExamAvailable(state),
  timer: getTimer(state),
  timerStarted: getTimerStarted(state),
  examQuestions: getExamQuestions(state),
  resultsSummarized: getResultsSummarized(state),
  practiceExam: getPracticeExam(state),
  submitPracticeExamLoading: getSubmitPracticeExamLoading(state),
  submitPracticeExamSuccess: getSubmitPracticeExamSuccess(state),
  checkPracticeExamLoading: getcheckPracticeExamLoading(state),
  checkPracticeExamFlag: getcheckPracticeExamFlag(state),
  reviewMode: getReviewMode(state),
  userSubscription: getUserSubscription(state),
  retakeMode: getRetakeMode(state),
  customPracticeExamStatus: getCustomPracticeExamStatus(state),
  customPracticeExam: getCustomPracticeExam(state),
});

const mapDispatchToProps = (dispatch) => ({
  setCheckPracticeExamStatusFlag: (flag) =>
    dispatch(setCheckPracticeExamStatusFlag(flag)),
  startPracticeExam: (userPracticeExamId, practiceExamId, isCustom) =>
    dispatch(startPracticeExam(userPracticeExamId, practiceExamId, isCustom)),
  getWeeklyPracticeExams: () => dispatch(getWeeklyPracticeExams()),
  updateTimerPracticeExam: () => dispatch(updateTimerPracticeExam()),
  setNewDetail: (detail) => dispatch(setNewDetail(detail)),
  updatePracticeExamResults: (examId, results, isCustom = false) =>
    dispatch(updatePracticeExamResults(examId, results, isCustom)),
  submitPracticeExam: (examId, results, isCustom) =>
    dispatch(submitPracticeExam(examId, results, isCustom)),
  setSubmitPracticeExamSuccess: (value) =>
    dispatch(setSubmitPracticeExamSuccess(value)),
  setReviewMode: (value) => dispatch(setReviewMode(value)),
  setPracticeExam: (exam) => dispatch(setPracticeExam(exam)),
  setExamQuestions: (questions) => dispatch(setExamQuestions(questions)),
  setResultsSummarized: (results) => dispatch(setResultsSummarized(results)),
  verifyLoggedUser: () => verifyLoggedUser(),
  loadUserSubscription: () => dispatch(loadUserSubscription()),
  setRetakeMode: (value) => dispatch(setRetakeMode(value)),
  setInitialTimePracticeExam: (value) =>
    dispatch(setInitialTimePracticeExam(value)),
  resetPracticeExamHistory: () => dispatch(resetPracticeExamHistory()),
  getPracticeExamQuestions: (examId, isCustom) =>
    dispatch(getPracticeExamQuestions(examId, isCustom)),
});

const PracticeExamContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(PracticeExamView);

export default PracticeExamContainer;
